import React, { useState, useEffect, useRef } from 'react'
import PageHeaderComponent from '../../../common/PageHeader';
import { Divider, message } from 'antd';
import { InfoCircleOutlined, RightOutlined } from '@ant-design/icons';
import moment from 'moment';
import '../../style/BulkReferralStyle.scss'
import { uploadReferralList, bulkListAndSummaryAPI } from './../../../../service/bulkActionService'
import { useHistory } from 'react-router-dom';
import * as loginService from '../../../../service/loginService';
import { getMitraTeamMembersList } from './../../../../service/commonService'
import BulkReferralStepOne from "./BulkReferralStepOne";
import BulkReferralStepTwo from "./BulkReferralStepTwo";
import BulkReferralStepThree from "./BulkReferralStepThree";
import BulkReferralSummary from "./BulkReferralSummary";

const BulkReferralContainer = ({ }) => {
    const history = useHistory();
    const [currentTab, setCurrentTab] = useState('bulk-referrals')
    const [breadcrumb, setBreadcrumb] = useState([{ link: '/', label: 'Home' }, { link: '/bulk-actions', label: "Bulk Actions" }, { link: '/', label: "Bulk Referral" }]);
    const [stepsList, setStepsList] = useState([
        {
            key: "step1",
            label: "Step 1: Select Job Details",
            isSelected: true,
            isCompleted: false
        },
        {
            key: "step2",
            label: "Step 2: Add Team Member(s)",
            isSelected: false,
            isCompleted: false
        },
        {
            key: "step3",
            label: "Step 3: Upload File",
            isSelected: false,
            isCompleted: false
        },
        {
            key: "summary",
            label: "Summary",
            isSelected: false,
            isCompleted: false
        }
    ])
    const [currentStep, setCurrentStep] = useState("step1")
    const [stepOneDataCity, setStepOneDataCity] = useState(null)
    const [stepOneDataJobCategory, setStepOneDataJobCategory] = useState(null)
    const [stepOneDataClient, setStepOneDataClient] = useState(null)
    const [stepOneDataJobLocation, setStepOneDataJobLocation] = useState(null)
    const [stepOneDataAvailableJob, setStepOneDataAvailableJob] = useState(null)
    const [stepTwoMitraTeamMembersList, setStepTwoMitraTeamMembersList] = useState(undefined)
    const [stepThreeFile, setStepThreeFile] = useState([])
    const [stepThreeUploading, setStepThreeUploading] = useState(false)

    const [mitra, setMitra] = useState({})
    const [mitraTeamList, setMitraTeamList] = useState([])

    const [bulkReferralSummary, setBulkReferralSummary] = useState([
        {
            "bulkUploadId": "",
            "uploadedBy": "",
            "totalLeads": 0,
            "uploadedURL": "",
            "errorReportUrl": "",
            "processStatus": "",
            "bulkUploadUniquenessLeadId": "",
            "metaData": {
                "companyName": "",
                "jobLocation": ""
            },
            "city": "",
            "uploadedAt": "",
            "processedLeads": 0,
            "nonUnique": 0,
            "unique": 0,
            "failedCount": 0
        }
    ])
    const scrollStepsRef = useRef(null);


    useEffect(() => {
        loginService
            .validateSession()
            .then((response) => {
                setMitra(response.data.mitra);
                getMitraTeamMembersList(true).then(res => {
                    let mitraNameNumberArray = res.data.data.map(ele => {
                        return {
                            value: ele.id,
                            label: `${ele.name} - ${ele.phoneNumber}`
                        }
                    })
                    mitraNameNumberArray = [{ value: response.data.mitra.id, label: `${response.data.mitra.name} - ${response.data.mitra.phoneNumber}` }, ...mitraNameNumberArray]
                    setMitraTeamList(mitraNameNumberArray)
                });

            })
            .catch((error) => history.push('/'));
    }, [])


    const proceedToNext = (stepKey) => {
        switch (stepKey) {
            case "step1":
                updateCurrentStep("step1", "step2")
                break;
            case "step2":
                updateCurrentStep("step2", "step3")
                break;
            case "step3":
                updateCurrentStep("step3", "step4")
                break;
            default:
                return;
        }
    }

    const goToStep = (step, stepInd) => {
        for (let i = 0; i < stepsList.length; i++) {
            if (stepsList[i].key == step.key && (step.isCompleted || stepsList[stepInd - 1] && stepsList[stepInd - 1].isCompleted)) {
                stepsList[i].isSelected = true;
                setCurrentStep(step.key)
            }
            else {
                stepsList[i].isSelected = false;
            }
        }
    }

    const updateCurrentStep = (currentStepKey, nextStepKey) => {
        for (let i = 0; i < stepsList.length; i++) {
            if (stepsList[i].key == currentStepKey) {
                stepsList[i].isCompleted = true;
            }
            if (stepsList[i].key == nextStepKey) {
                stepsList[i].isSelected = true;
            }
            else {
                stepsList[i].isSelected = false;
            }
        }
        setCurrentStep(nextStepKey)

        if (nextStepKey == "step3" || nextStepKey == "step4") {
            if (scrollStepsRef && scrollStepsRef.current) {
                scrollStepsRef.current.scrollLeft += 400
            }
        }
    }

    const markStepAsIncomplete = (prevStepKey) => {
        for (let i = 0; i < stepsList.length; i++) {
            if (stepsList[i].key == prevStepKey && prevStepKey !== "first") {
                stepsList[i].isCompleted = true;
            }
            else {
                stepsList[i].isCompleted = false;
            }
        }
    }

    const markStepAsComplete = (stepKey) => {
        for (let i = 0; i < stepsList.length; i++) {
            if (stepsList[i].key == stepKey) {
                stepsList[i].isCompleted = true;
                break;
            }
        }
    }

    const uploadBulkDataAPI = () => {
        setStepThreeUploading(true);
        const bulkAPIData = new FormData();
        bulkAPIData.append('files', stepThreeFile);
        bulkAPIData.append('city', stepOneDataCity);
        bulkAPIData.append('category', stepOneDataJobCategory);
        bulkAPIData.append('companyName', stepOneDataClient);
        bulkAPIData.append('jobId', stepOneDataAvailableJob[0].id);
        bulkAPIData.append('jobLocation', stepOneDataJobLocation);
        bulkAPIData.append('jobDemandId', stepOneDataAvailableJob[0].jobDemandId);
        bulkAPIData.append('mitraManagerId', mitra.id);
        bulkAPIData.append('mitraListSelected', stepTwoMitraTeamMembersList && stepTwoMitraTeamMembersList.length > 0 ? JSON.stringify(stepTwoMitraTeamMembersList) : JSON.stringify([mitra.id]));
        uploadReferralList(bulkAPIData).then(response => {
            console.log(response)
            if (response && response.data && response.data.status) {
                if (response?.data?.data && response.data?.data?.bulkUploadUniquenessLeadId) {
                    getReferredLeadsSummary(response.data.data.bulkUploadUniquenessLeadId)
                }
                else {
                    message.error(`Something went wrong, please try again in sometime.`, 5);
                }
            }
            else {
                message.error(`Something went wrong, please try again in sometime.`, 5);
            }
        })
            .catch(err => {
                setStepThreeUploading(false)
                if (err.response?.data?.candidateResponse) {
                    message.error(`Something went wrong, please check the downloaded error sheet`, 8);
                    downloadErrorResponseSheet(err.response?.data?.candidateResponse)
                }
                else if (err.response?.data?.error) {
                    message.error(`Something went wrong: ${err.response.data.error}`, 5);
                }
                else {
                    message.error(`Something went wrong: ${err}`, 5);
                }
            })
    }

    const downloadErrorResponseSheet = (errorResponseUrl) => {
        const link = document.createElement('a');
        link.href = errorResponseUrl;
        link.download = 'upload-errors.xlsx'; // Specify the desired filename

        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
    }

    const getReferredLeadsSummary = (leadEntryId = "") => {
        bulkListAndSummaryAPI(0, moment().format("YYYY-MM-DD"), moment().add(1, 'days').format("YYYY-MM-DD"), null, null, leadEntryId, null).then((summaryRes) => {
            if (summaryRes && summaryRes?.data && summaryRes?.data?.data) {
                setStepThreeUploading(false);
                proceedToNext("step3")
                setCurrentStep("summary")
                setBulkReferralSummary(summaryRes.data.data)
            }
        }).catch((err) => {
            setStepThreeUploading(false);
            message.error(`Something went wrong: ${err}`, 5);
        })
    }

    const handleStepOneDataChange = (dataKey = "", dataVal, stepKey = "") => {
        if (stepKey == "first") {

            switch (dataKey) {
                case "city":
                    if (stepOneDataCity !== dataVal) {
                        markStepAsIncomplete("first")
                    }
                    // else {
                    //     markStepAsComplete("first")
                    // }
                    setStepOneDataCity(dataVal);
                    break;
                case "category":
                    if (stepOneDataJobCategory !== dataVal) {
                        markStepAsIncomplete("first")
                    }
                    // else {
                    //     markStepAsComplete("first")
                    // }
                    setStepOneDataJobCategory(dataVal);
                    break;
                case "client":
                    if (stepOneDataClient !== dataVal) {
                        markStepAsIncomplete("first")
                    }
                    // else {
                    //     markStepAsComplete("first")
                    // }
                    setStepOneDataClient(dataVal);
                    break;
                case "location":
                    if (stepOneDataJobLocation !== dataVal) {
                        markStepAsIncomplete("first")
                    }
                    // else {
                    //     markStepAsComplete("first")
                    // }
                    setStepOneDataJobLocation(dataVal);
                    break;
            }
        }
    }

    return (
        <div className='bulk-referral-new-parent'>
            <div className="containerTop">
                <div className="header">
                    <>
                        <PageHeaderComponent backBtnBool={true} breadcrumb={breadcrumb} />
                    </>
                </div>

            </div>

            <Divider></Divider>

            <div className='br-below-divider h-100'>
                <div className='d-flex align-items-center'>
                    <InfoCircleOutlined className='br-info-icon' />
                    <div className='br-info-txt'>
                        You will need to upload a file of candidate names and their phone numbers. You can download the template of the file <u><em><a href="https://uploads-a.vahan.co/uBUqb8-bulk-action-template.xlsx">here</a></em></u>.
                    </div>
                </div>

                <div className='show-only-desktop'>
                    <div className='br-steps-parent d-flex align-items-center w-100'>
                        {
                            stepsList.map((step, stepInd) => {
                                return (
                                    <div key={stepInd} className={`br-step br-cp d-flex align-items-center justify-content-center ${stepInd !== stepsList.length - 1 ? 'br-step-w30' : 'br-step-w20'}`} id={`${stepInd == 2 ? "br-scroll-into-view" : ""}`} onClick={() => goToStep(step, stepInd)}>
                                        <div className={`br-step-txt ${currentStep == step.key ? "br-active-step" : ""}`}>
                                            {step.label}
                                        </div>
                                        <div className='br-step-arrow-img d-flex'>
                                            {stepInd + 1 < stepsList.length ? <RightOutlined /> : null}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>

                <div className='show-only-mobile'>
                    <div className='br-steps-parent d-flex align-items-center' ref={scrollStepsRef}>
                        {
                            stepsList.map((step, stepInd) => {
                                return (
                                    <div key={stepInd} className={`br-step-mobile br-cp d-flex align-items-center justify-content-center ${stepInd !== stepsList.length - 1 ? 'br-step-mobile-w75' : 'br-step-mobile-w65'}`} onClick={() => goToStep(step, stepInd)}>
                                        <div className={`br-step-txt ${currentStep == step.key ? "br-active-step" : ""}`}>
                                            {step.label}
                                        </div>
                                        <div className='br-step-arrow-img d-flex'>
                                            {stepInd + 1 < stepsList.length ? <RightOutlined /> : null}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>


                {

                    currentStep == "step1" ?
                        <BulkReferralStepOne
                            selectedCityFromParent={stepOneDataCity}
                            selectedJobCategoryFromParent={stepOneDataJobCategory}
                            selectedClientFromParent={stepOneDataClient}
                            selectedJobLocationFromParent={stepOneDataJobLocation}
                            returnStepOneCity={(city) => {
                                handleStepOneDataChange("city", city, "first");
                                // setStepOneDataCity(city);
                            }}
                            returnStepOneJobCategory={(category) => {
                                handleStepOneDataChange("category", category, "first");
                                // handleStepOneJobCategoryChange(category)
                            }}
                            returnStepOneClient={(client) => {
                                handleStepOneDataChange("client", client, "first");
                                // setStepOneDataClient(client); 
                            }}
                            returnStepOneJobLocation={(location) => {
                                handleStepOneDataChange("location", location, "first");
                                //  setStepOneDataJobLocation(location); 
                            }}
                            returnStepOneAvailableJobs={(availableJob) =>
                                setStepOneDataAvailableJob(availableJob)
                            }
                            goToNextStep={() => proceedToNext("step1")}
                            clearedStep={() => markStepAsIncomplete("first")} /> :
                        currentStep == "step2" ?
                            <BulkReferralStepTwo
                                mitra={mitra}
                                mitraTeamList={mitraTeamList}
                                selectedMitraTeamMembersFromParent={stepTwoMitraTeamMembersList}
                                returnStepTwoMitraTeamMemberList={(data) => setStepTwoMitraTeamMembersList(data)}
                                goToNextStep={() => proceedToNext("step2")}
                                clearedStep={() => markStepAsIncomplete("step1")} /> :
                            currentStep == "step3" ?
                                <BulkReferralStepThree
                                    selectedFileFromParent={stepThreeFile}
                                    returnStepThreeUploadedFile={(data) => setStepThreeFile(data)}
                                    onUploadClicked={() => uploadBulkDataAPI()}
                                    isUploading={stepThreeUploading} /> :
                                <BulkReferralSummary summaryData={bulkReferralSummary} />
                }
            </div>
        </div>
    )
}

export default BulkReferralContainer; 